// import * as format from './components/input-formatter';
// import lightbox from './components/lightbox';
// import modal from './components/modal';
// import tabs from './components/tabs';
// import fileUploader from './components/file-uploader';
// import carousel from './components/carousel';
// import multiSelect from './components/multi-select';
// import datePicker from './components/datepicker';

import showHide from './functions/showhide';
import browserDeviceDetect from './functions/browser-device-detect';
import Flickity from 'flickity';

document.addEventListener('DOMContentLoaded', () => {
	const bgSetupItems = Array.from(document.querySelectorAll('.bg-setup'));

	if (bgSetupItems.length != 0) {
		bgSetupItems.forEach((item) => {
			setupBackground(item);
		});
	}
	
	const modalBgs = document.querySelectorAll('.modal .modal-background');
	if (modalBgs) {
		modalBgs.forEach(item => {
			item.addEventListener('click', (e) => {
				item.parentNode.classList.remove('is-active');
			});
		});
	}

	const modalCloses = document.querySelectorAll('.modal .modal-close');
	if (modalCloses) {
		modalCloses.forEach(item => {
			item.addEventListener('click', (e) => {
				item.parentNode.classList.remove('is-active');
			});
		});
	}

  browserDeviceDetect();
  showHide();
});

window.onload = () => {
	const mainCarousel = document.querySelector('.main-carousel');
	if (mainCarousel) {
		let flickity = new Flickity(mainCarousel, {
			wrapAround: true,
			prevNextButtons: false,
			setGallerySize: false,
			autoPlay: false
		});
	}

	// const filter = document.querySelector('.result-filter');

	// if (filter) {
	// 	let filterSlider = new Flickity('.result-filter', {
	// 		prevNextButtons: false,
	// 		pageDots: false,
	// 		resize: true,
	// 		contain: true
	// 	});
	// }

	const relevantArticles = document.querySelector('.relevant-articles');

	if (relevantArticles) {
		if (window.innerWidth < 769) {
			let relevantArticlesSlider = new Flickity('.relevant-articles', {
				prevNextButtons: false,
				pageDots: false,
				resize: true,
				contain: true,
				imagesLoaded: true
			});
		}
	}
};

function setupBackground(bgItem) {
	let backgroundUrl = bgItem.dataset.background;

	bgItem.style.backgroundImage = `url("${backgroundUrl}")`;
}



// WEBPACK FOOTER //
// ./resources/assets/js/app.js